import { render, staticRenderFns } from "./widthdraw.vue?vue&type=template&id=663af57b&"
import script from "./widthdraw.vue?vue&type=script&lang=js&"
export * from "./widthdraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports